import { render, staticRenderFns } from "./receiptInfo.vue?vue&type=template&id=2765cbe3&"
import script from "./receiptInfo.vue?vue&type=script&lang=js&"
export * from "./receiptInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports